import CommonTable from "./CommonTable";
export default CommonTable;
